import { useTranslation } from 'react-i18next'

import { SelectStatus } from '@/components'
import { QUERIES_ADMIN, useSupplierOrderEdit } from '@/services'
import { SupplyOrderProps } from '@/types'
import { showToast } from '@mercai/clever'
import { useQueryClient } from '@tanstack/react-query'

import { supplyOrderStatusOptions } from './select-supply-order-status.constants'

import { SelectSupplyOrderStatusProps } from './select-supply-order-status.type'

export const SelectSupplyOrderStatus = ({
  supplyOrder,
  size = 'medium',
}: SelectSupplyOrderStatusProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenSupplyOrderDetail')

  const queryClient = useQueryClient()

  const supplyOrderStatusOptionsByRole = supplyOrderStatusOptions(tEnums)

  const { mutateAsync } = useSupplierOrderEdit(supplyOrder?.uuid)

  const onUpdate = (success: boolean, message?: string) => {
    if (success) {
      queryClient.invalidateQueries({
        queryKey: [QUERIES_ADMIN.SUPPLIER_ORDER.module, supplyOrder?.uuid],
      })
    } else {
      showToast({
        variant: 'error',
        title: message || t('errorMessageDescription'),
      })
    }
  }

  const onUpdateOrderStatus = async (status: SupplyOrderProps['status']) => {
    const response = await mutateAsync({ status })

    onUpdate(response?.success, response?.message)
  }

  return (
    <div>
      <SelectStatus
        size={size}
        status={supplyOrder?.status}
        options={supplyOrderStatusOptionsByRole}
        onChange={async (status) => {
          await onUpdateOrderStatus(status as SupplyOrderProps['status'])
        }}
        excludeOptions={['cancelled']}
      />
    </div>
  )
}
